module.exports = now

function now() {
    return new Date().getTime()
}



//////////////////
// WEBPACK FOOTER
// ../~/date-now/index.js
// module id = 11
// module chunks = 0